import dayjs from "dayjs";
import { RefreshCw } from "lucide-react";
import { useHistory } from "react-router-dom";

import { Filter } from "../../../../components/ui/Filter";
import { Input } from "../../../../components/ui/Form/Input";
import { CrmPetDiagnosisController } from "../../../../services/controllers/crmPetDiagnosis";
import { CRM_PET_DIAGNOSIS_TABS, useCrmPetDiagnosis } from "../../../../store/crmPetDiagnosis/useCrmPetDiagnosis";
import { PERIOD_OPTIONS } from "../constants";
import { PeriodButton } from "../components/PeriodButton";

export function ActivityFilter() {
  const controller = CrmPetDiagnosisController();
  const history = useHistory();
  const filters = useCrmPetDiagnosis((state) => state.data.filters.activity);
  const loading = useCrmPetDiagnosis((state) => state.data.loading.usage);

  return (
    <Filter.Root
      onSubmit={(event) =>
        controller.applyFilters(CRM_PET_DIAGNOSIS_TABS.activity, event, history)
      }
    >
      <Filter.Container>
        <div className="flex w-full flex-wrap gap-2 pb-2">
          {PERIOD_OPTIONS.map((option) => (
            <PeriodButton
              key={option.value}
              option={option}
              active={filters.period === option.value}
              onSelect={(period) =>
                controller.setPeriod(CRM_PET_DIAGNOSIS_TABS.activity, period)
              }
              onApply={() =>
                controller.applyFilters(CRM_PET_DIAGNOSIS_TABS.activity, null, history)
              }
            />
          ))}
        </div>
        <div className="flex w-full flex-wrap gap-3">
          <Input.Root
            pickDate
            label="Início"
            value={dayjs(filters.from).format("DD/MM/YYYY")}
            onChange={(value) =>
              controller.setDate(CRM_PET_DIAGNOSIS_TABS.activity, "from", value)
            }
          />
          <Input.Root
            pickDate
            label="Fim"
            value={dayjs(filters.to).format("DD/MM/YYYY")}
            onChange={(value) =>
              controller.setDate(CRM_PET_DIAGNOSIS_TABS.activity, "to", value)
            }
          />
        </div>
      </Filter.Container>
      <Filter.Actions>
        <Filter.Action isLoading={loading}>
          <Filter.ActionIcon icon={RefreshCw} isLoading={loading} />
          Atualizar atividade
        </Filter.Action>
      </Filter.Actions>
    </Filter.Root>
  );
}
